import { useEffect, useState } from "react";
import { CONFIG, UNITS } from "@/staticData";
import { scrollToId } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Accommodation from "@/components/Accommodation";
import Gallery from "@/components/Gallery";
import Amenities from "@/components/Amenities";
import Quiz from "@/components/Quiz";
import Experiences from "@/components/Experiences";
import Breakfast from "@/components/Breakfast";
import Attractions from "@/components/Attractions";
import RasnovStory from "@/components/RasnovStory";
import ViaTransilvanica from "@/components/ViaTransilvanica";
import FestivalRadar from "@/components/FestivalRadar";
import AfterDark from "@/components/AfterDark";
import Retreats from "@/components/Retreats";
import Reviews from "@/components/Reviews";
import Host from "@/components/Host";
import BookingSection from "@/components/BookingSection";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CampaignBanner from "@/components/CampaignBanner";
import FloatingTools from "@/components/FloatingTools";
import MyTransylvania from "@/components/MyTransylvania";

export default function Landing() {
  const [config] = useState(CONFIG);
  const [units] = useState(UNITS.filter((u) => u.active));
  const [prefill, setPrefill] = useState({ unitType: "room", checkIn: "", checkOut: "", adults: 2, children: 0, pet: false });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => scrollToId(id), 800);
      setTimeout(() => scrollToId(id), 2000);
    }
  }, []);

  const selectUnit = (type) => {
    setPrefill((p) => ({ ...p, unitType: type }));
  };

  return (
    <div className="relative" data-testid="landing-page">
      <Header config={config} />
      <main>
        <Hero config={config} prefill={prefill} setPrefill={setPrefill} />
        <CampaignBanner />
        <Marquee />
        <Story />
        <Accommodation units={units} onSelect={selectUnit} config={config} />
        <BookingSection units={units} config={config} prefill={prefill} />
        <Gallery />
        <Amenities />
        <Quiz config={config} units={units} />
        <Experiences />
        <Breakfast />
        <Attractions config={config} />
        <RasnovStory />
        <ViaTransilvanica config={config} />
        <FestivalRadar />
        <AfterDark />
        <Retreats config={config} />
        <Reviews config={config} />
        <Host config={config} />
        <Faq />
      </main>
      <Footer config={config} />
      <WhatsAppFloat config={config} />
      <FloatingTools />
      <MyTransylvania config={config} />
    </div>
  );
}
